{
  "common": {
    "actions": {
      "add": "Add",
      "cancel": "Cancel",
      "clear": "Clear",
      "clearFilters": "Clear filters",
      "close": "Close",
      "copy": "Copy",
      "copyAll": "Copy all",
      "dismiss": "Dismiss",
      "edit": "Edit",
      "filter": "Filter",
      "next": "Next",
      "previous": "Previous",
      "retry": "Retry",
      "save": "Save",
      "saveChanges": "Save changes",
      "search": "Search",
      "signIn": "Sign in",
      "signOut": "Sign out",
      "tryAgain": "Try again"
    },
    "labels": {
      "account": "Account",
      "actions": "Actions",
      "administrator": "Administrator",
      "created": "Created",
      "currency": "Currency",
      "description": "Description",
      "email": "Email",
      "lastSignIn": "Last sign-in",
      "loading": "Loading",
      "mfa": "MFA",
      "name": "Name",
      "none": "None",
      "password": "Password",
      "plan": "Plan",
      "reason": "Reason",
      "region": "Region",
      "role": "Role",
      "slug": "Slug",
      "status": "Status",
      "timezone": "Timezone",
      "unlimited": "Unlimited",
      "user": "User"
    },
    "mfa": {
      "enrolled": "Enrolled",
      "notEnrolled": "Not enrolled"
    },
    "roles": {
      "billing": "Billing",
      "owner": "Owner",
      "support": "Support"
    },
    "userStatus": {
      "active": "Active",
      "disabled": "Disabled",
      "invited": "Invited",
      "locked": "Locked"
    },
    "validation": {
      "emailInvalid": "Enter a valid email address.",
      "emailRequired": "Email is required.",
      "nameRequired": "Name is required.",
      "passwordRequired": "Password is required.",
      "reasonMinLength": "{label} must be at least {min} characters — it is recorded on the audit trail.",
      "reasonPlaceholder": "At least {min} characters",
      "reasonRequired": "{label} is required."
    }
  },
  "ui": {
    "button": {
      "working": "Working"
    },
    "field": {
      "optional": "optional",
      "required": "(required)"
    },
    "money": {
      "negative": "negative {amount}"
    },
    "select": {
      "clear": "None",
      "placeholder": "Select…"
    },
    "pagination": {
      "empty": "No records",
      "label": "Pagination",
      "nextPage": "Next page",
      "perPage": "{size} per page",
      "previousPage": "Previous page",
      "showing": "Showing {range}",
      "showingOfTotal": "Showing {range} of {total}"
    },
    "table": {
      "chooseColumns": "Choose columns",
      "columns": "Columns",
      "emptyTitle": "Nothing to show yet",
      "filteredDescription": "Try widening the date range or clearing a filter chip.",
      "filteredTitle": "No records match these filters",
      "recordCountOne": "{count} record",
      "recordCountOther": "{count} records",
      "selectAllRows": "Select all rows on this page",
      "selectRow": "Select row {index}",
      "visibleColumns": "Visible columns"
    },
    "panel": {
      "emptyTitle": "Nothing here yet"
    }
  },
  "errors": {
    "generic": "Something went wrong.",
    "loadTitle": "That did not load",
    "trace": "Trace {id}",
    "slugTaken": "That slug is already taken. Choose another.",
    "slugTakenShort": "That slug is already taken.",
    "slugRejected": "The server rejected this slug: it must be 3–30 characters of lowercase letters, digits or underscores.",
    "codes": {
      "ERR_BUDGET_EXCEEDED": "This would take the budget past its available balance.",
      "ERR_CONFLICT": "Someone else changed this first. Reload and try again.",
      "ERR_CREDIT_LIMIT": "This customer is over their credit limit.",
      "ERR_DUPLICATE_INVOICE": "An invoice with this number already exists for this vendor.",
      "ERR_FORBIDDEN": "Your role does not permit this action.",
      "ERR_IDEMPOTENCY_MISMATCH": "This request was already sent with different content. Reload and try again.",
      "ERR_ILLEGAL_TRANSITION": "That status change is not allowed from where this record is now.",
      "ERR_INTERNAL": "The server could not complete this. It has been logged — try again, and quote the trace id if it keeps failing.",
      "ERR_MFA_REQUIRED": "Multi-factor authentication is required before you can do this.",
      "ERR_NOT_FOUND": "That record no longer exists.",
      "ERR_PERIOD_CLOSED": "The accounting period is closed, so nothing can be posted into it.",
      "ERR_RATE_LIMITED": "Too many requests. Wait a moment and try again.",
      "ERR_ROW_VERSION": "This record changed while you were editing it. Reload it and reapply your changes.",
      "ERR_SOD_VIOLATION": "Segregation of duties: the same person cannot both raise and approve this.",
      "ERR_STEP_UP_REQUIRED": "Confirm your identity with your authenticator before doing this.",
      "ERR_TENANT_SUSPENDED": "This tenant is suspended. Reactivate it before making changes.",
      "ERR_UNAUTHENTICATED": "Your session has ended. Sign in again.",
      "ERR_PACK_IMMUTABLE": "This pack has been published and its content can no longer be changed. Draft a new version from it instead.",
      "ERR_PACK_DUAL_CONTROL": "The operator who submitted a pack cannot publish it. A second owner has to.",
      "ERR_PACK_VALIDATION": "The payload has unresolved validation issues, so it cannot be published.",
      "ERR_PACK_NOT_SUBMITTED": "This pack has not been submitted for publication yet.",
      "ERR_TAX_PACK_NOT_ACTIVATED": "This tenant has not activated a pack for that country.",
      "ERR_TAX_PACK_NO_ENTITY": "No company operates in that country yet, so there is nothing for this pack to apply to.",
      "ERR_TAX_PACK_NOT_PUBLISHED": "No published tax pack exists for that country yet.",
      "ERR_TAX_PACK_ALREADY_ACTIVATED": "This country's tax pack is already activated for this tenant."
    }
  },
  "routes": {
    "appName": "erpx platform admin",
    "documentTitle": "{title} · erpx admin",
    "login": "Sign in",
    "mfaEnrol": "Set up authentication",
    "dashboard": "Platform",
    "tenants": "Tenants",
    "tenantCreate": "Onboard a tenant",
    "tenantCreateCrumb": "Onboard",
    "tenantDetail": "Tenant",
    "plans": "Plans",
    "admins": "Platform admins",
    "notFound": "Not found",
    "billing": "Billing",
    "subscriptions": "Subscriptions",
    "subscription": "Subscription",
    "invoices": "Invoices",
    "invoice": "Invoice",
    "payments": "Payments",
    "forgotPassword": "Reset password",
    "resetPassword": "Choose a new password",
    "acceptInvite": "Accept invitation"
  },
  "nav": {
    "primaryLabel": "Primary",
    "platform": {
      "label": "Platform",
      "description": "Tenant counts, signups, health"
    },
    "tenants": {
      "label": "Tenants",
      "description": "Onboarding, lifecycle, support"
    },
    "plans": {
      "label": "Plans",
      "description": "Entitlements and pricing"
    },
    "billing": {
      "label": "Billing",
      "description": "Subscriptions, invoices, payments"
    },
    "admins": {
      "label": "Platform admins",
      "description": "Operators and their roles"
    },
    "group": {
      "localization": "Localization"
    },
    "geography": {
      "label": "Geography",
      "description": "Countries, subdivisions, localities"
    },
    "taxPacks": {
      "label": "Tax packs",
      "description": "Rates and rules, draft to published"
    },
    "taxPackAdoption": {
      "label": "Pack adoption",
      "description": "Which tenant runs which version"
    },
    "signedInAs": "Signed in as {role}.",
    "roleNote": {
      "billing": "Support helpers and tenant lifecycle actions are closed to this role.",
      "support": "Plan and administrator changes are owner-only."
    }
  },
  "shell": {
    "skipToContent": "Skip to content",
    "brandSuffix": "platform admin",
    "collapseNav": "Collapse navigation",
    "expandNav": "Expand navigation",
    "searchButton": "Search tenants, plans and actions",
    "footerHint": "Press {key} for keyboard shortcuts",
    "breadcrumbLabel": "Breadcrumb",
    "breadcrumbRoot": "Platform",
    "menu": {
      "shortcuts": "Keyboard shortcuts",
      "signOut": "Sign out"
    },
    "theme": {
      "toDark": "Switch to dark theme",
      "toLight": "Switch to light theme"
    },
    "locale": {
      "label": "Language",
      "trigger": "Change language",
      "current": "Current language: {language}"
    },
    "shortcuts": {
      "title": "Keyboard shortcuts",
      "description": "Everything currently bound on this screen.",
      "groups": {
        "approvals": "Approvals",
        "document": "Documents",
        "global": "Anywhere",
        "grid": "Grids",
        "list": "Lists",
        "navigation": "Navigation"
      },
      "commandPalette": "Open the command palette",
      "cheatSheet": "Show keyboard shortcuts",
      "quickCreate": "Onboard a new tenant"
    },
    "copy": {
      "toastTitle": "{what} copied",
      "toastBody": "It is on your clipboard.",
      "failedTitle": "Could not copy automatically",
      "failedBody": "Select the text and copy it with your keyboard.",
      "defaultWhat": "Value",
      "buttonLabel": "Copy {what} to the clipboard",
      "copied": "Copied"
    }
  },
  "palette": {
    "title": "Command palette",
    "listLabel": "Commands",
    "placeholder": "Search tenants, screens and actions…",
    "empty": "No matching command",
    "hint": {
      "close": "to close",
      "escKey": "Esc",
      "navigate": "to navigate",
      "run": "to run"
    },
    "groups": {
      "create": "Create",
      "goTo": "Go to",
      "preferences": "Preferences",
      "tenants": "Tenants"
    },
    "items": {
      "dashboard": "Platform dashboard",
      "tenants": "Tenants",
      "plans": "Plans",
      "admins": "Platform admins",
      "onboard": "Onboard a tenant",
      "onboardHint": "Runs the provisioning saga with live step progress",
      "themeToDark": "Switch to dark theme",
      "themeToLight": "Switch to light theme",
      "localeSwitch": "Switch language to {language}"
    }
  },
  "auth": {
    "login": {
      "title": "Platform admin",
      "intro": "Operator access to every tenant on this deployment. Multi-factor authentication is required on this realm.",
      "emailLabel": "Email",
      "passwordLabel": "Password",
      "codeLabel": "Authentication code",
      "codeHint": "Six digits from your authenticator app.",
      "submit": "Sign in",
      "submitWithCode": "Verify and sign in",
      "mfaPrompt": "Enter the six-digit code from your authenticator app.",
      "failed": "Sign-in failed. Check your details and try again.",
      "forgot": "I have forgotten my password"
    },
    "mfa": {
      "title": "Set up two-factor authentication",
      "intro": "This console requires an authenticator on every account. Until this is done the rest of the platform admin is closed to you — that is the server's rule, not this screen's.",
      "scanTitle": "Scan this code",
      "scanStep": "Open your authenticator app and scan the code.",
      "confirmStep": "Enter the six digits it shows to confirm the pairing.",
      "manualIntro": "Can't scan? Enter this key manually:",
      "setupKeyWhat": "Setup key",
      "codeLabel": "Authentication code",
      "codeInvalid": "Enter the six digits shown in your authenticator app.",
      "codeRejected": "That code did not verify. Try the next one.",
      "confirm": "Confirm",
      "enrolFailed": "Enrolment could not start",
      "qrLabel": "Authenticator enrolment QR code",
      "recovery": {
        "title": "Save your recovery codes",
        "body": "Each code signs you in once if you lose your authenticator.",
        "onlyOnce": "They are stored only as hashes, so this is the only time they can be shown.",
        "keepSafe": "Keep them somewhere you would keep a password.",
        "what": "Recovery codes",
        "acknowledge": "I have stored these codes somewhere safe",
        "continue": "Continue to the console"
      },
      "wrongAccount": "Wrong account?"
    },
    "backToSignIn": "Back to sign in",
    "forgot": {
      "title": "Reset your password",
      "description": "Enter the address your platform admin account uses. If it matches an active account, a reset link is emailed to it.",
      "submit": "Email me a link",
      "sent": "If that address has a platform admin account, a link is on its way. It expires in an hour, so use it soon.",
      "noEnumeration": "The answer is the same either way — this page will not tell you whether an address is registered.",
      "failed": "The reset link could not be requested. Try again."
    },
    "reset": {
      "title": "Choose a new password",
      "intro": "This link can be used once. Choose a password you do not use anywhere else.",
      "newPassword": "New password",
      "passwordHint": "At least 12 characters. A short sentence you will remember works well.",
      "confirmPassword": "Type it again",
      "tooShort": "Use at least 12 characters.",
      "mismatch": "The two passwords do not match.",
      "submit": "Save new password",
      "missingToken": "This page needs the link from your email — open it from there rather than typing the address.",
      "requestAnother": "Send me a new link",
      "failed": "That link is no longer valid. Links expire and can only be used once.",
      "doneTitle": "Password changed",
      "doneBody": "Sign in with your new password. This console will then ask for your authenticator code."
    },
    "invite": {
      "title": "Set up your operator account",
      "intro": "You have been invited as a platform administrator. Choose a password to finish setting up the account.",
      "submit": "Set password",
      "missingToken": "This page needs the link from your invitation email — open it from there rather than typing the address.",
      "failed": "That invitation is no longer valid. Invitations expire — ask an owner to send a new one.",
      "doneTitle": "Account ready",
      "doneBody": "Sign in with your new password. Multi-factor authentication is required on this realm, so the next step is enrolling an authenticator."
    }
  },
  "stepUp": {
    "title": "Confirm it's you",
    "reasons": {
      "support": "Acting on a tenant user needs your authenticator.",
      "billing": "Changing billing needs your authenticator.",
      "tenant": "Changing this tenant needs your authenticator.",
      "generic": "This action needs your authenticator."
    },
    "description": "Enter the six-digit code from your authenticator app. What you were doing carries on the moment it is accepted — nothing you entered is lost.",
    "codeLabel": "Authentication code",
    "submit": "Confirm",
    "verifying": "Checking",
    "waiting": "One action is waiting behind this. | {count} actions are waiting behind this.",
    "attemptsWarning": "Wrong codes count towards the same lockout that applies to signing in.",
    "errors": {
      "code": "That code was not accepted. If you have just used this one, wait for your app to show the next code.",
      "lockout": "Too many incorrect codes. This account is locked for a short while — the same limit that applies to signing in.",
      "lockoutUntil": "Too many incorrect codes. Try again after {time}.",
      "other": "The code could not be checked. Try again in a moment."
    },
    "enrol": {
      "routedTitle": "Finish setting up your authenticator",
      "routedDetail": "That action needs a second factor this account cannot produce yet. Complete enrolment, then try it again."
    }
  },
  "dashboard": {
    "title": "Platform",
    "description": "Tenant estate, onboarding volume and the health of the services behind it.",
    "loadFailed": "The dashboard could not load",
    "kpi": {
      "tenants": "Tenants",
      "tenantsHelp": "Every tenant in the registry, whatever its status.",
      "tenantsDrilldown": "View all tenants",
      "active": "Active",
      "activeDrilldown": "View active tenants",
      "suspended": "Suspended",
      "suspendedDrilldown": "View suspended tenants",
      "behind": "Schemas behind",
      "behindHelp": "Tenants whose schema version is behind the shipped migrations, or whose last migration left it dirty. Open a tenant to migrate it.",
      "behindDrilldown": "View tenants"
    },
    "signups": {
      "title": "Signups",
      "description": "New tenants per day.",
      "emptyTitle": "No tenants have been onboarded yet",
      "emptyDescription": "Onboard the first one from the Tenants screen.",
      "chartLabel": "New tenants per day",
      "series": "Signups"
    },
    "health": {
      "title": "Service health",
      "database": "Database",
      "redis": "Redis",
      "healthy": "Healthy",
      "unreachable": "Unreachable"
    },
    "clusters": {
      "title": "Tenants by cluster",
      "description": "Where each tenant's schema lives.",
      "emptyTitle": "No clusters in use yet"
    },
    "revenueNote": "Revenue and churn are not shown here. They are derived from subscriptions, which are not part of the platform data model yet, and a zero would read as \"no revenue\" rather than \"not measured\"."
  },
  "tenants": {
    "status": {
      "provisioning": {
        "label": "Provisioning",
        "meaning": "The provisioning saga is still running. Users cannot sign in yet."
      },
      "provisioningFailed": {
        "label": "Provisioning failed",
        "meaning": "A provisioning step failed. Resume it from the tenant’s provisioning view."
      },
      "active": {
        "label": "Active",
        "meaning": "Fully provisioned. Users can sign in and work normally."
      },
      "suspended": {
        "label": "Suspended",
        "meaning": "Users receive 403 responses and see a suspension banner."
      },
      "archived": {
        "label": "Archived",
        "meaning": "The schema has been dumped to storage and dropped."
      }
    },
    "list": {
      "title": "Tenants",
      "description": "Every tenant in the registry, its lifecycle status and where its schema lives.",
      "tableLabel": "Tenants",
      "onboard": "Onboard a tenant",
      "roleNote": "Onboarding and lifecycle actions require the owner or support role.",
      "loadFailed": "Tenants could not be loaded",
      "emptyTitle": "No tenants yet",
      "emptyDescription": "Onboard the first tenant to provision its schema, seed it and invite its administrator.",
      "searchLabel": "Search tenants",
      "searchPlaceholder": "Search name or slug",
      "statusLabel": "Filter by status",
      "anyStatus": "Any status",
      "noPlan": "No plan",
      "columns": {
        "tenant": "Tenant",
        "status": "Status",
        "plan": "Plan",
        "region": "Region",
        "timezone": "Timezone",
        "users": "Users",
        "created": "Created",
        "lastSignIn": "Last sign-in"
      }
    },
    "create": {
      "title": "Onboard a tenant",
      "description": "Creates the registry row, the schema, its migrations, the seed data and the first administrator — as one saga you can watch.",
      "roleWarning": "Onboarding requires the owner or support role. This form will be rejected by the server.",
      "detailsTitle": "Tenant details",
      "nameLabel": "Tenant name",
      "namePlaceholder": "Velaa Trading Pte",
      "nameRequired": "Tenant name is required.",
      "slugLabel": "Slug",
      "regionLabel": "Region",
      "regionHint": "Where this tenant's workloads are served from.",
      "regionPlaceholder": "Choose a region",
      "regions": {
        "blr1": "Bangalore (blr1)",
        "sgp1": "Singapore (sgp1)",
        "fra1": "Frankfurt (fra1)",
        "ams3": "Amsterdam (ams3)",
        "lon1": "London (lon1)",
        "nyc3": "New York (nyc3)",
        "sfo3": "San Francisco (sfo3)",
        "tor1": "Toronto (tor1)",
        "syd1": "Sydney (syd1)"
      },
      "timezoneLabel": "Timezone",
      "timezoneHint": "IANA zone. Business dates, period boundaries and every scheduled job run in it.",
      "timezoneHintOffset": "IANA zone. Business dates, period boundaries and every scheduled job run in it. Currently {offset}.",
      "timezoneInvalid": "Choose a timezone from the list.",
      "planLabel": "Plan",
      "planHint": "Determines entitled modules and limits.",
      "planHintNone": "No active plans exist yet — a tenant can be onboarded without one and assigned a plan later.",
      "planPlaceholder": "No plan",
      "adminNameLabel": "Administrator name",
      "adminNameRequired": "Administrator name is required.",
      "adminEmailLabel": "Administrator email",
      "adminEmailHint": "Receives the invite that sets their password.",
      "adminEmailInvalid": "Enter the administrator’s email address.",
      "submit": "Provision tenant",
      "failed": "The tenant could not be created.",
      "provisioningTitle": "Provisioning",
      "provisioningRunning": "Running — this view updates itself.",
      "provisioningFinished": "Finished.",
      "provisioningStopped": "Stopped at a failed step.",
      "openTenant": "Open tenant",
      "onboardAnother": "Onboard another",
      "resumedTitle": "Provisioning resumed",
      "resumedBody": "The saga picked up from the failed step.",
      "resumeFailed": "Resume failed.",
      "credentialTiming": "A password is written after the tenant is provisioned, over a separate request — it is never part of the onboarding payload, so it is not queued or stored anywhere on the way.",
      "credentialRunning": "Setting the administrator's password…",
      "credentialFailedTitle": "The tenant is ready, but setting the password failed",
      "credentialFailedAdvice": "The tenant itself is provisioned and usable — do not onboard it again. Retry here, or open the tenant and set the password from its users list.",
      "credentialRetry": "Try again",
      "credentialFailed": "The administrator's password could not be set.",
      "credentialUserMissing": "No user with the address {email} was found in this tenant, so there was nobody to set a password for.",
      "credentialDone": "The password for {email} is set. They will be asked to choose their own at first sign-in unless you turned that off."
    },
    "slug": {
      "rule": "3–30 characters, lowercase letters, digits and underscores only. Permanent once created.",
      "required": "Slug is required.",
      "tooShort": "Slug must be at least 3 characters.",
      "tooLong": "Slug must be at most 30 characters.",
      "notLowercase": "Slug must be lowercase — uppercase letters are not allowed.",
      "charset": "Slug may contain only lowercase letters, digits and underscores.",
      "reserved": "\"{slug}\" is reserved. Choose another slug."
    },
    "provisioning": {
      "steps": {
        "registry_row": "Create the registry row",
        "create_schema": "Create the tenant schema",
        "migrate_schema": "Apply tenant migrations",
        "seed": "Seed currencies, localization pack, roles and sequences",
        "create_admin": "Create the tenant administrator and send the invite",
        "activate": "Activate the tenant"
      },
      "stepStatus": {
        "pending": "Not started",
        "running": "Running",
        "completed": "Done",
        "failed": "Failed"
      },
      "attempts": "{count} attempt | {count} attempts",
      "failedNote": "The saga stopped at the failed step. Resuming picks up from there — it does not recreate anything that already succeeded.",
      "resume": "Resume provisioning",
      "resumeRoleNote": "Resuming requires the owner or support role.",
      "complete": "All steps completed. The tenant is provisioned and its administrator has been invited.",
      "panelTitle": "Provisioning saga",
      "panelDescription": "The six steps that create a tenant.",
      "panelDescriptionFailed": "Stopped at a failed step.",
      "loadFailed": "The step ledger could not be read",
      "resumedToast": "Provisioning resumed",
      "resumeFailedToast": "Resume failed"
    },
    "detail": {
      "fallbackTitle": "Tenant",
      "subtitle": "{slug} · schema {schema} · cluster {cluster}",
      "loadFailed": "This tenant could not be loaded",
      "tabsLabel": "Tenant sections",
      "tabs": {
        "overview": "Overview",
        "usage": "Usage",
        "users": "Users",
        "audit": "Audit",
        "provisioning": "Provisioning"
      },
      "settingsTitle": "Settings",
      "settingsDescription": "Changes here are audited under your identity.",
      "nameLabel": "Tenant name",
      "timezoneLabel": "Timezone",
      "timezoneHint": "Business dates, period boundaries and every scheduled job run in this zone.",
      "timezoneHintOffset": "Business dates, period boundaries and every scheduled job run in this zone. Currently {offset}.",
      "timezoneChanged": "Changing the timezone is recorded on the audit trail. It takes effect for the next day's business dates and scheduled jobs; nothing already stored is rewritten.",
      "planLabel": "Plan",
      "planHint": "Determines the modules and limits this tenant is entitled to.",
      "planPlaceholder": "No plan",
      "planRetired": "{name} (retired)",
      "planPrice": "{currency} {price} per {interval}",
      "editRoleNote": "Editing a tenant requires the owner or support role.",
      "saveFailed": "The tenant could not be updated.",
      "savedTitle": "Tenant updated",
      "savedBody": "The change is recorded on the platform audit trail.",
      "registryTitle": "Registry",
      "registry": {
        "slug": "Slug",
        "schema": "Schema",
        "cluster": "Cluster",
        "region": "Region",
        "baseCurrency": "Base currency",
        "locale": "Locale",
        "storagePrefix": "Storage prefix",
        "created": "Created",
        "activated": "Activated",
        "suspended": "Suspended",
        "reason": "Reason"
      },
      "schemaTitle": "Schema version",
      "schemaDescription": "Migrations applied to this tenant's schema.",
      "schemaVersion": "Version {version} of {latest}",
      "schemaDirty": "The last migration left this schema dirty. Migrating will retry it.",
      "schemaBehind": "Behind the shipped migrations.",
      "schemaUpToDate": "Up to date.",
      "migrateNow": "Migrate now",
      "migratedTitle": "Schema migrated",
      "migratedBody": "Now at version {version} of {latest}.",
      "migrateFailed": "Migration failed",
      "flagsTitle": "Feature flags",
      "flagsDescription": "Per-tenant switches read by the API. Keys are exactly as the server stores them.",
      "flagsAddLabel": "New flag key",
      "flagsEmpty": "No feature flags set. This tenant follows its plan's entitlements.",
      "flagsNote": "Flag changes are applied with Save changes.",
      "limitsTitle": "Custom limits",
      "limitsDescription": "Overrides on top of the plan's limits. Whole numbers.",
      "limitsAddLabel": "New limit key",
      "limitsEmpty": "No overrides. Plan limits apply.",
      "limitsNote": "Limit changes are applied with Save changes.",
      "suspend": "Suspend",
      "reactivate": "Reactivate",
      "suspendTitle": "Suspend this tenant",
      "suspendConsequence": "Their users will receive 403 responses with a suspension banner and will not be able to sign in or post anything. Data is untouched and reactivating restores access immediately.",
      "suspendConfirm": "Suspend tenant",
      "suspendReasonHint": "Recorded on the tenant record and the audit trail.",
      "suspendedTitle": "Tenant suspended",
      "suspendedBody": "Its users now receive 403 responses.",
      "suspendFailed": "The tenant could not be suspended.",
      "reactivateTitle": "Reactivate this tenant",
      "reactivateConsequence": "Their users can sign in and work again immediately. The suspension stays on the audit trail.",
      "reactivateConfirm": "Reactivate tenant",
      "reactivatedTitle": "Tenant reactivated",
      "reactivatedBody": "Its users can sign in again.",
      "reactivateFailed": "The tenant could not be reactivated."
    },
    "usage": {
      "loadFailed": "Usage could not be loaded",
      "rangeLabel": "Usage range",
      "range": {
        "days30": "Last 30 days",
        "days90": "Last 90 days",
        "days180": "Last 180 days",
        "months12": "Last 12 months"
      },
      "activityTitle": "Activity",
      "activityDescription": "Rolled up nightly per tenant day.",
      "activityEmptyTitle": "No usage recorded yet",
      "activityEmptyDescription": "Rollups appear the day after a tenant starts being used.",
      "activityChartLabel": "Tenant activity per day",
      "series": {
        "activeUsers": "Active users",
        "apiCalls": "API calls",
        "documentsPosted": "Documents posted",
        "aiTokens": "AI tokens",
        "storage": "Storage"
      },
      "storageTitle": "Storage",
      "storageDescription": "Bytes held under this tenant's storage prefix.",
      "storageEmptyTitle": "No storage recorded yet",
      "storageEmptyDescription": "Attachments and generated documents are counted here once uploaded.",
      "storageChartLabel": "Tenant storage per day"
    },
    "audit": {
      "tableLabel": "Tenant audit log",
      "loadFailed": "The audit log could not be read",
      "emptyTitle": "No audit entries yet",
      "emptyDescription": "Every create, update, status change, login and export inside this tenant lands here.",
      "entityLabel": "Entity",
      "entityPlaceholder": "Entity, e.g. gl.journal",
      "actionLabel": "Action",
      "actionPlaceholder": "Action, e.g. post",
      "columns": {
        "when": "When",
        "action": "Action",
        "entity": "Entity",
        "actor": "Actor",
        "note": "Note"
      }
    },
    "keyValue": {
      "keyInvalid": "Use lowercase letters, digits, dots or underscores (2–49 characters).",
      "keyExists": "That key already exists.",
      "limitsInvalid": "Limits must be whole numbers.",
      "enable": "Enable {key}",
      "remove": "Remove {key}"
    }
  },
  "support": {
    "session": {
      "title": "Support access",
      "description": "A time-boxed, read-only token for looking inside this tenant.",
      "intro": "Opening a support session mints a token that can read this tenant for two hours. It cannot change anything, the tenant's users see a banner while it is active, and every request made with it is audited under your identity.",
      "open": "Open a support session",
      "roleNote": "Support access requires the owner or support role.",
      "activeUntil": "Session active until {expires}. This token is shown once — it is not stored by this console.",
      "tokenWhat": "Support token",
      "revoke": "Revoke session",
      "dialogTitle": "Open a support session",
      "dialogDescription": "Read-only access to {tenant} for two hours.",
      "dialogConsequence": "The token can read this tenant's data. Its users will see a “support session active” banner, and every action taken with it is recorded on the audit trail under your name.",
      "dialogConfirm": "Open session",
      "reasonHint": "Why you need access — this is stored on the session and shown to auditors.",
      "openedTitle": "Support session opened",
      "openedBody": "It expires automatically in two hours.",
      "openFailed": "The support session could not be opened.",
      "revokedTitle": "Support session revoked",
      "revokedBody": "The token no longer works.",
      "revokeFailed": "Could not revoke"
    },
    "users": {
      "tableLabel": "Tenant users",
      "readOnlyNote": "Support helpers require the owner or support role. This list is read-only for you.",
      "loadFailed": "This tenant's users could not be loaded",
      "emptyTitle": "No users in this tenant yet",
      "emptyDescription": "The administrator invited during provisioning appears here once the invite is accepted.",
      "actionsFor": "Support actions for {email}",
      "actionFailed": "That action did not complete.",
      "columns": {
        "user": "User",
        "status": "Status",
        "mfa": "MFA",
        "lastSignIn": "Last sign-in"
      },
      "actions": {
        "resetPassword": {
          "label": "Send password reset link",
          "title": "Send a password reset link",
          "consequence": "The user receives an email with a reset link on their own address, and their current password keeps working until they use it. This helper shows you nothing — it is the only path where nobody but the user ever knows their password, so prefer it whenever they have a working mailbox. Use “Set a password” when they do not.",
          "confirm": "Send link",
          "done": "Reset link sent"
        },
        "unlock": {
          "label": "Unlock account",
          "title": "Unlock this account",
          "consequence": "Clears the failed-login lockout so the user can try again immediately. It does not change their password.",
          "confirm": "Unlock",
          "done": "Account unlocked"
        },
        "resetMfa": {
          "label": "Reset multi-factor authentication",
          "title": "Reset multi-factor authentication",
          "consequence": "Removes the user’s authenticator. They will be asked to enrol a new one on their next sign-in, and until they do their account is protected by password alone.",
          "confirm": "Reset MFA",
          "done": "Authenticator reset"
        },
        "resendInvite": {
          "label": "Resend invite",
          "title": "Resend the invite",
          "consequence": "Issues a fresh invite link and emails it. Any previous invite link stops working.",
          "confirm": "Resend",
          "done": "Invite resent"
        },
        "deactivate": {
          "label": "Deactivate user",
          "title": "Deactivate this user",
          "consequence": "The user can no longer sign in and their sessions end. Their records and audit history are kept — this is not a deletion.",
          "confirm": "Deactivate",
          "done": "User deactivated"
        },
        "revokeSessions": {
          "label": "Force sign-out everywhere",
          "title": "Force sign-out everywhere",
          "consequence": "Every active session and refresh token for this user is revoked. They will have to sign in again on each device.",
          "confirm": "Sign them out",
          "done": "Sessions revoked"
        }
      }
    },
    "credentials": {
      "modeLabel": "How they get in",
      "modeHint": "An invitation is the only option where nobody but the user ever knows their password. The other two exist for accounts with no working mailbox.",
      "modes": {
        "invite": {
          "label": "Send an invitation",
          "hint": "Emails a link. They choose their own password and you never see one. Recommended."
        },
        "set": {
          "label": "Set a password",
          "hint": "You type it and pass it on yourself. No email is sent."
        },
        "generate": {
          "label": "Generate a password",
          "hint": "We mint one and show it to you once. It is stored nowhere and cannot be looked up again."
        }
      },
      "passwordLabel": "Password",
      "passwordHint": "At least {min} characters. Length is the whole rule — no character classes are required.",
      "confirmLabel": "Confirm password",
      "show": "Show",
      "hide": "Hide",
      "passwordRequired": "Enter a password, or choose another option above.",
      "passwordTooShort": "Use at least {min} characters.",
      "passwordTooLong": "Use at most {max} characters.",
      "passwordAllSame": "A single repeated character is not a password.",
      "mismatch": "The two passwords do not match.",
      "mustChangeLabel": "Require the user to change it at first sign-in",
      "mustChangeDescription": "Recommended. The password you set stops working the moment they choose their own, so what you know expires by itself.",
      "mustChangeOffWarning": "With this unticked you keep knowing a password that goes on working indefinitely, and so does anyone you pass it to. Leave it off only for an account that is deliberately shared."
    },
    "generatedPassword": {
      "title": "Password — shown once",
      "onlyTimeShown": "This is the only time this password is displayed. It is stored nowhere and cannot be retrieved again; if it is lost, set a new one for {subject}.",
      "copyWhat": "Password",
      "expiresAtFirstSignIn": "The user will be asked to choose their own password at first sign-in, after which this one stops working.",
      "doesNotExpire": "You chose not to force a change, so this password goes on working until somebody changes it.",
      "deliveryAdvice": "Hand it over in person or on a channel you trust. Do not email it — an inbox is exactly what the invitation path would have used.",
      "acknowledge": "I have saved this password somewhere safe",
      "dismiss": "Done"
    },
    "createUser": {
      "open": "Add user",
      "title": "Add a user to this tenant",
      "description": "Creates the account inside the tenant's own schema. Everything here is recorded on the tenant's audit trail under your name.",
      "nameLabel": "Full name",
      "nameRequired": "A name is required.",
      "emailLabel": "Email",
      "emailHint": "Their sign-in address. It must be unique within this tenant.",
      "emailInvalid": "Enter their email address.",
      "rolesLabel": "Role codes",
      "rolesHint": "Comma-separated codes, e.g. accountant, ap_clerk. Leave blank and the tenant's own administrator assigns roles from inside their app, where the catalogue is.",
      "overrideReasonLabel": "Override reason",
      "overrideReasonHint": "These roles conflict under segregation of duties. Saying why is what lets the combination through, and it is stored on the audit row.",
      "overrideReasonRequired": "A reason is required to override a segregation-of-duties conflict.",
      "submit": "Create user",
      "failed": "The user could not be created.",
      "done": "User created"
    },
    "setPassword": {
      "label": "Set a password",
      "title": "Set this user's password",
      "consequence": "This signs the user out of every device and clears any invitation or reset link already sent to them — those links stop working. Sending a reset link instead is the better path whenever they have a working mailbox.",
      "submit": "Set password",
      "failed": "That password could not be set.",
      "done": "Password set"
    }
  },
  "plans": {
    "title": "Plans",
    "description": "What a tenant is entitled to, and what it is billed for.",
    "tableLabel": "Plans",
    "new": "New plan",
    "roleNote": "Creating and editing plans requires the owner or billing role.",
    "loadFailed": "Plans could not be loaded",
    "emptyTitle": "No plans yet",
    "emptyDescription": "A plan bundles modules, a user cap and a price. Tenants can be onboarded without one and assigned a plan later.",
    "createFirst": "Create the first plan",
    "retired": "Retired",
    "allModules": "All modules",
    "moreModules": "+{count} more",
    "columns": {
      "plan": "Plan",
      "price": "Price",
      "billed": "Billed",
      "trial": "Trial",
      "userCap": "User cap",
      "modules": "Modules",
      "status": "Status"
    },
    "interval": {
      "monthly": "Monthly",
      "annual": "Annual"
    },
    "edit": {
      "newTitle": "New plan",
      "editTitle": "Edit {name}",
      "newDescription": "Codes are permanent once created.",
      "codeLabel": "Code",
      "codeHint": "Permanent identifier used by entitlement checks.",
      "codeInvalid": "Lowercase letters, digits, dashes and underscores; 2–30 characters.",
      "nameLabel": "Name",
      "namePlaceholder": "Growth",
      "nameRequired": "Plan name is required.",
      "descriptionLabel": "Description",
      "priceLabel": "Price",
      "priceHint": "Per billing interval.",
      "priceInvalid": "Enter an amount such as 499 or 499.00.",
      "currencyLabel": "Currency",
      "currencyInvalid": "Three-letter ISO 4217 code, e.g. MVR.",
      "intervalLabel": "Billing interval",
      "trialLabel": "Trial days",
      "trialInvalid": "Whole number of days.",
      "userCapLabel": "User cap",
      "userCapHint": "Blank means unlimited.",
      "userCapPlaceholder": "Unlimited",
      "userCapInvalid": "Whole number, or leave blank for unlimited.",
      "sortLabel": "Sort order",
      "sortHint": "Lower sorts first.",
      "modulesLegend": "Entitled modules",
      "wildcardNote": "“All modules” entitles everything; individual selections are ignored while it is on.",
      "activeLabel": "Active",
      "activeDescription": "A retired plan stays on the tenants that already have it, but cannot be chosen for new ones.",
      "create": "Create plan",
      "save": "Save plan",
      "createdTitle": "Plan created",
      "updatedTitle": "Plan updated",
      "saveFailed": "The plan could not be saved."
    },
    "modules": {
      "groups": {
        "everything": "Everything",
        "foundation": "Foundation",
        "finance": "Finance",
        "operations": "Operations",
        "people": "People",
        "platform": "Platform"
      },
      "all": "All modules",
      "org": "Enterprise",
      "gl": "General ledger",
      "ap": "Accounts payable",
      "ar": "Accounts receivable",
      "cash": "Cash & bank",
      "bankrec": "Bank reconciliation",
      "budget": "Budgeting",
      "assets": "Fixed assets",
      "consol": "Consolidation",
      "procurement": "Procurement",
      "inventory": "Inventory",
      "sales": "Sales",
      "crm": "CRM",
      "mfg": "Manufacturing",
      "projects": "Projects",
      "service": "Service",
      "hr": "HR",
      "payroll": "Payroll",
      "portal": "Portals",
      "reporting": "Reporting",
      "ai": "AI layer"
    }
  },
  "billing": {
    "roleNote": "Recording payments and changing plans requires the owner or billing role.",
    "planPrice": "{currency} {price} per {interval}",
    "nav": {
      "label": "Billing sections",
      "subscriptions": "Subscriptions",
      "invoices": "Invoices",
      "payments": "Payments"
    },
    "fields": {
      "tenant": "Tenant",
      "currentPlan": "Current plan",
      "planPrice": "Plan price",
      "unitPrice": "Unit price",
      "seats": "Seats",
      "interval": "Billed",
      "trialDays": "Trial days",
      "trialEnds": "Trial ends",
      "periodStart": "Period from",
      "periodEnd": "Period to",
      "period": "Period",
      "cancelsAtPeriodEnd": "Ends at period end",
      "cancelledAt": "Cancelled",
      "invoice": "Invoice",
      "issuedOn": "Issued",
      "dueOn": "Due",
      "subtotal": "Subtotal",
      "tax": "Tax",
      "total": "Total",
      "paid": "Paid",
      "balance": "Balance",
      "amount": "Amount",
      "quantity": "Quantity",
      "lineDescription": "Description",
      "receivedOn": "Received on",
      "method": "Method",
      "reference": "Reference",
      "note": "Note"
    },
    "subscriptionStatus": {
      "trialing": {
        "label": "Trialing",
        "meaning": "In its trial. Nothing has been billed yet."
      },
      "active": {
        "label": "Active",
        "meaning": "Billing normally each period."
      },
      "pastDue": {
        "label": "Past due",
        "meaning": "An invoice is overdue. Dunning is running and the service is still on."
      },
      "suspended": {
        "label": "Suspended",
        "meaning": "Service is cut off for non-payment. Reactivate once the invoice is settled."
      },
      "cancelled": {
        "label": "Cancelled",
        "meaning": "Ended. Nothing further is billed."
      }
    },
    "invoiceStatus": {
      "draft": {
        "label": "Draft",
        "meaning": "Raised but not yet issued to the tenant."
      },
      "open": {
        "label": "Open",
        "meaning": "Issued and awaiting payment."
      },
      "paid": {
        "label": "Paid",
        "meaning": "Settled in full."
      },
      "void": {
        "label": "Void",
        "meaning": "Withdrawn. It counts towards nothing owed."
      },
      "uncollectible": {
        "label": "Uncollectible",
        "meaning": "Written off as unrecoverable."
      }
    },
    "paymentMethod": {
      "bankTransfer": "Bank transfer",
      "cheque": "Cheque",
      "cash": "Cash",
      "card": "Card"
    },
    "subscriptions": {
      "title": "Subscriptions",
      "description": "Every tenant's plan, what it bills each period, and where it is in its lifecycle.",
      "tableLabel": "Subscriptions",
      "statusLabel": "Status",
      "anyStatus": "Any status",
      "clearTenantFilter": "Clear tenant filter",
      "manage": "Manage",
      "emptyTitle": "No subscriptions yet",
      "emptyDescription": "Assign a plan to a tenant and it will appear here.",
      "loadFailed": "Subscriptions could not be loaded"
    },
    "detail": {
      "title": "Subscription",
      "description": "Plan, billing period and lifecycle for this tenant.",
      "panelTitle": "Subscription",
      "viewInvoices": "View invoices",
      "noneTitle": "This tenant has no subscription",
      "noneDescription": "Assign a plan to start billing. Nothing is invoiced until a plan is assigned.",
      "cancelScheduled": "This subscription is set to end on {date}. Reactivate it to keep billing.",
      "cancellationReason": "Reason given: {reason}",
      "loadFailed": "This subscription could not be loaded"
    },
    "assign": {
      "title": "Assign a plan",
      "intro": "The plan sets what this tenant is entitled to and what it is billed each period.",
      "planPlaceholder": "Choose a plan",
      "planRequired": "Choose a plan.",
      "seatsHint": "Leave blank to use the plan's own user cap.",
      "seatsInvalid": "Seats must be a whole number.",
      "trialHint": "Leave blank to use the plan's own trial length.",
      "trialInvalid": "Trial days must be a whole number.",
      "submit": "Assign plan",
      "failed": "The plan could not be assigned.",
      "doneTitle": "Plan assigned"
    },
    "changePlan": {
      "title": "Change plan",
      "planLabel": "New plan",
      "planPlaceholder": "Choose a plan",
      "planRequired": "Choose the plan to move to.",
      "currentPlanHint": "The plan this tenant is on now.",
      "effectiveLabel": "When it takes effect",
      "effectiveHint": "This decides whether the customer is billed twice this month, so there is no default.",
      "effectiveRequired": "Choose when the change takes effect.",
      "effective": {
        "now": "Immediately",
        "nowHint": "The current period is closed off and billed, and a new period starts today on the new plan. The customer sees two charges this month.",
        "periodEnd": "At the end of the period on {date}",
        "periodEndHint": "This period is billed as it stands and the new plan applies from the next renewal, so there is one charge this month."
      },
      "submit": "Change plan",
      "failed": "The plan could not be changed.",
      "doneTitle": "Plan changed"
    },
    "cancel": {
      "title": "Cancel subscription",
      "timingLabel": "When to stop",
      "timing": {
        "periodEnd": "At the end of the period on {date}",
        "periodEndHint": "They keep the service already billed for, and are not invoiced again.",
        "now": "Immediately",
        "nowHint": "Billing stops today. The unused part of the period is not refunded from this screen."
      },
      "consequencePeriodEnd": "Billing stops after {date}. The tenant keeps working until then and no further invoice is raised.",
      "consequenceNow": "Billing stops now and no further invoice is raised. The unused part of the current period is not refunded from this screen.",
      "reasonHint": "Recorded on the subscription and on the audit trail.",
      "keep": "Keep the subscription",
      "submit": "Cancel subscription",
      "failed": "The subscription could not be cancelled.",
      "doneTitle": "Subscription cancelled"
    },
    "reactivate": {
      "submit": "Reactivate",
      "failed": "The subscription could not be reactivated.",
      "doneTitle": "Subscription reactivated"
    },
    "invoices": {
      "title": "Invoices",
      "description": "Platform invoices raised against tenant subscriptions and metered usage.",
      "tableLabel": "Invoices",
      "statusLabel": "Status",
      "anyStatus": "Any status",
      "fromLabel": "Issued from",
      "toLabel": "Issued to",
      "emptyTitle": "No invoices yet",
      "emptyDescription": "Generate the first billing period and the invoices will appear here.",
      "generateFirst": "Generate the first billing period",
      "loadFailed": "Invoices could not be loaded"
    },
    "invoice": {
      "title": "Invoice",
      "description": "Lines, payments and the outstanding balance, exactly as the server computed them.",
      "headerPanel": "Invoice",
      "linesPanel": "Lines",
      "linesTableLabel": "Invoice lines",
      "noLinesTitle": "This invoice has no lines",
      "noLinesDescription": "An invoice with no lines was raised with nothing to bill for. Void it and generate the period again.",
      "paymentsPanel": "Payments",
      "paymentsTableLabel": "Payments against this invoice",
      "noPaymentsTitle": "Nothing received yet",
      "noPaymentsDescription": "Record a bank transfer, cheque or cash payment once the money has arrived.",
      "subtotalMismatch": "The lines on this invoice do not add up to the subtotal the server sent. Nothing here has been recalculated to cover it up. Report this before acting on the figures.",
      "totalMismatch": "The subtotal plus tax does not equal the total the server sent. Nothing here has been recalculated to cover it up. Report this before acting on the figures.",
      "voidedReason": "Voided: {reason}",
      "loadFailed": "This invoice could not be loaded"
    },
    "payment": {
      "title": "Record a payment",
      "appliesTo": "Allocated to invoice {number}",
      "amountHint": "In {currency}, as the money arrived.",
      "amountInvalid": "Enter the amount as a number.",
      "amountNotPositive": "The amount must be more than zero.",
      "receivedOnHint": "The date the money arrived, not the date it is keyed in.",
      "dateRequired": "Enter the date the money arrived.",
      "referenceHint": "The bank reference or cheque number, so it can be traced later.",
      "referenceRequired": "Enter the reference the money arrived with.",
      "overpaymentWarning": "That is {excess} more than this invoice has outstanding. It is recorded against this invoice alone; nothing is allocated to the tenant's other invoices from this screen.",
      "overpaymentAcknowledge": "I have checked the amount received.",
      "submit": "Record payment",
      "failed": "The payment could not be recorded.",
      "doneTitle": "Payment recorded"
    },
    "payments": {
      "title": "Payments",
      "description": "Everything received, by date, with the reference it arrived under.",
      "tableLabel": "Payments",
      "fromLabel": "Received from",
      "toLabel": "Received to",
      "emptyTitle": "Nothing received yet",
      "emptyDescription": "Payments are recorded on the invoice they pay. Open an invoice to record one.",
      "loadFailed": "Payments could not be loaded"
    },
    "void": {
      "title": "Void invoice",
      "consequence": "The invoice is withdrawn and stops counting towards what the tenant owes. It is never deleted and its number is never reused.",
      "consequencePaid": "This invoice already has money recorded against it. Voiding it withdraws the document but leaves those payments recorded, so reconcile them first.",
      "reasonHint": "Recorded on the invoice and on the audit trail.",
      "submit": "Void invoice",
      "failed": "The invoice could not be voided.",
      "doneTitle": "Invoice voided"
    },
    "generate": {
      "title": "Generate invoices",
      "description": "Raise the platform invoices for one billing period.",
      "periodStart": "Period from",
      "periodEnd": "Period to",
      "dateRequired": "Enter a date.",
      "endBeforeStart": "The end of the period cannot be before its start.",
      "tenantLabel": "One tenant only",
      "tenantHint": "Leave blank to bill every eligible tenant.",
      "allTenants": "All tenants",
      "idempotencyNote": "The run is idempotent: a tenant already invoiced for these dates is skipped, never billed twice.",
      "review": "Review",
      "back": "Back",
      "submit": "Generate invoices",
      "confirmAll": "Invoices will be raised for every eligible tenant for the period from {start} to {end}.",
      "confirmOne": "An invoice will be raised for {tenant} for the period from {start} to {end}.",
      "confirmDetail": "Tenants already invoiced for this period are skipped. Check the dates before you continue.",
      "failed": "The invoice run could not be completed.",
      "resultSummary": "Run for the period from {start} to {end}.",
      "noTenants": "No tenant was eligible for this period.",
      "tableLabel": "Invoice run outcome by tenant",
      "outcome": {
        "generated": "Generated",
        "skipped": "Skipped"
      },
      "skippedMeaning": "Already invoiced for this period."
    }
  },
  "admins": {
    "title": "Platform administrators",
    "description": "Who can operate this deployment, and with what authority.",
    "tableLabel": "Platform administrators",
    "invite": "Invite administrator",
    "ownerOnlyNote": "Inviting, changing roles, disabling and removing administrators are owner-only actions. You can see the list.",
    "loadFailed": "Administrators could not be loaded",
    "emptyTitle": "No administrators",
    "emptyDescription": "At least one owner must exist for this deployment to be operable.",
    "actionsFor": "Actions for {email}",
    "columns": {
      "administrator": "Administrator",
      "role": "Role",
      "status": "Status",
      "mfa": "MFA",
      "lastSignIn": "Last sign-in"
    },
    "roles": {
      "ownerHint": "Full control, including other administrators",
      "supportHint": "Tenant lifecycle and support helpers",
      "billingHint": "Plans and billing; no support access"
    },
    "inviteDialog": {
      "title": "Invite an administrator",
      "description": "They receive an email with a link that sets their password. Multi-factor enrolment is then required before they can use the console.",
      "roleHint": "Owners can manage other administrators; support and billing cannot.",
      "submit": "Send invite",
      "sentTitle": "Invite sent",
      "sentBody": "{email} can now set a password.",
      "forbidden": "Only an owner can invite platform administrators.",
      "failed": "The invite could not be sent."
    },
    "roleDialog": {
      "title": "Change role",
      "note": "The change takes effect on their next request; it is recorded on the platform audit trail.",
      "submit": "Change role",
      "changedTitle": "Role changed",
      "changedBody": "{email} is now {role}.",
      "forbidden": "Only an owner can change an administrator’s role.",
      "failed": "The role could not be changed."
    },
    "menu": {
      "changeRole": "Change role",
      "enable": "Re-enable",
      "disable": "Disable",
      "remove": "Remove"
    },
    "confirm": {
      "removeTitle": "Remove this administrator",
      "removeConsequence": "{email} loses access immediately and every session is revoked. The account row is deleted — the audit trail keeps the record of who they were. This cannot be undone.",
      "removeConfirm": "Remove administrator",
      "enableTitle": "Re-enable this administrator",
      "enableConsequence": "{email} can sign in again with their existing password and authenticator.",
      "enableConfirm": "Re-enable",
      "disableTitle": "Disable this administrator",
      "disableConsequence": "{email} can no longer sign in. The account and its history are kept, and it can be re-enabled at any time.",
      "disableConfirm": "Disable",
      "doneTitle": "Done",
      "forbidden": "Only an owner can change platform administrators.",
      "failed": "That action did not complete."
    }
  },
  "notFound": {
    "title": "That screen does not exist",
    "description": "Nothing is routed at {path}. It may have been a link to a screen that has since moved, or a typo in the address bar.",
    "dashboard": "Platform dashboard",
    "tenants": "Tenants"
  },
  "geotax": {
    "routes": {
      "geography": "Geography",
      "taxPacks": "Tax packs",
      "taxPack": "Tax pack",
      "adoption": "Pack adoption",
      "tenantTaxPacks": "Tenant tax packs"
    },
    "nav": {
      "group": "Localization",
      "geography": "Geography",
      "taxPacks": "Tax packs",
      "adoption": "Adoption"
    },
    "roles": {
      "writeNote": "Editing geography needs the owner or support role.",
      "packWriteNote": "Drafting and editing packs needs the owner or support role.",
      "publishNote": "Publishing and withdrawing a pack is reserved to the owner role."
    },
    "geography": {
      "title": "Geography",
      "description": "The country, subdivision and locality master every tenant's addresses and tax jurisdictions resolve against.",
      "countriesLabel": "Countries",
      "searchLabel": "Search countries",
      "searchPlaceholder": "Name or ISO code",
      "activeOnly": "Active only",
      "emptyTitle": "No countries yet",
      "emptyDescription": "Import the ISO 3166 list to start, or add the one country this instance operates in.",
      "emptyFilteredTitle": "No country matches",
      "emptyFilteredDescription": "Nothing matches this search. Clear it to see the whole list.",
      "addCountry": "Add country",
      "importCountries": "Import ISO list",
      "loadFailed": "The country list could not be loaded.",
      "treeLoadFailed": "This country's subdivisions and localities could not be loaded.",
      "selectPrompt": "Select a country",
      "selectPromptDescription": "Pick a country on the left to see and edit its subdivisions and localities.",
      "addSubdivision": "Add {label}",
      "addLocality": "Add {label}",
      "noSubdivisions": "No {label} recorded yet",
      "noSubdivisionsDescription": "Add the first one, or import them with the country.",
      "inactive": "Inactive",
      "treeLabel": "Geography of {country}",
      "countTemplate": "{active} active of {total}"
    },
    "validation": {
      "title": "Address validation",
      "description": "How strictly a tenant's address form is held to this country's subdivision and locality master.",
      "enforce": "Enforce",
      "enforceHint": "An address must resolve to a recorded subdivision and locality. Anything else is rejected.",
      "warn": "Warn",
      "warnHint": "An unrecognised subdivision or locality is accepted, and flagged to the person entering it.",
      "allow": "Allow",
      "allowHint": "Free text is accepted without checking. Use for countries whose master is not loaded."
    },
    "country": {
      "createTitle": "Add a country",
      "editTitle": "Edit {name}",
      "createDescription": "ISO codes are the identity of the row and cannot be changed afterwards.",
      "editDescription": "The ISO codes are fixed. Everything else can be corrected.",
      "save": "Save country",
      "create": "Add country",
      "saveFailed": "The country could not be saved.",
      "iso2Hint": "Two-letter ISO 3166-1 alpha-2 code, e.g. MV.",
      "iso3Hint": "Three-letter ISO 3166-1 alpha-3 code, e.g. MDV.",
      "numericHint": "Three-digit ISO 3166-1 numeric code. Optional.",
      "currencyHint": "ISO 4217 code the country's packs file in, e.g. MVR.",
      "timezoneHint": "IANA zone, e.g. Indian/Maldives. Used as the default for tenants in this country.",
      "labelsTitle": "What the levels are called here",
      "labelsHint": "Atolls and islands in the Maldives, states and cities elsewhere. The words appear on every tenant's address form.",
      "iso2Invalid": "Enter exactly two letters.",
      "iso3Invalid": "Enter exactly three letters.",
      "numericInvalid": "Enter exactly three digits, or leave it empty.",
      "currencyInvalid": "Enter a three-letter ISO 4217 code.",
      "nameRequired": "A name is required.",
      "activeHint": "An inactive country is hidden from tenant address forms but keeps every row it already has."
    },
    "addressFormat": {
      "title": "Address format",
      "description": "Which address components this country expects, in what order, and whether a locality must be picked from the geography tree rather than typed.",
      "componentKeyPlaceholder": "Component key, e.g. line1",
      "required": "Required",
      "sourceFreeText": "Free text",
      "sourceGeo": "Must resolve to a geography row",
      "moveUp": "Move component up",
      "moveDown": "Move component down",
      "remove": "Remove component",
      "addComponent": "Add component",
      "noComponents": "No components yet — an address here only requires a first line.",
      "postalPattern": "Postal code pattern",
      "postalPatternHint": "An anchored regular expression, e.g. ^[0-9]{5}$. Leave empty for a country with no postal system.",
      "postalLabel": "Postal code label",
      "requiresGeoLocality": "Locality must resolve to a geography row",
      "requiresGeoLocalityHint": "When on, a location's locality/subdivision must be picked from the geography tree, not typed as free text — this is what makes its tax jurisdiction derivable."
    },
    "subdivision": {
      "createTitle": "Add {label}",
      "editTitle": "Edit {name}",
      "description": "A subdivision sits directly under the country, or under another subdivision at a higher level.",
      "save": "Save",
      "saveFailed": "The subdivision could not be saved.",
      "levelHint": "1 for a top-level subdivision, 2 for one nested inside another.",
      "parentNone": "No parent — directly under the country",
      "codeHint": "Short code, unique within the country. Appears in jurisdiction codes.",
      "codeRequired": "A code is required.",
      "nameRequired": "A name is required."
    },
    "locality": {
      "createTitle": "Add {label}",
      "editTitle": "Edit {name}",
      "description": "A locality is the smallest addressable unit — an island, a city, a free zone.",
      "save": "Save",
      "saveFailed": "The locality could not be saved.",
      "subdivisionNone": "No subdivision — directly under the country",
      "postalHint": "Postal or ZIP code, where the country uses one.",
      "timezoneHint": "Only where it differs from the country's own zone.",
      "codeRequired": "A code is required.",
      "nameRequired": "A name is required."
    },
    "import": {
      "title": "Import countries",
      "description": "Paste rows of ISO 3166 data. Existing countries are updated on their alpha-2 code; new ones are created.",
      "inputLabel": "Country rows",
      "inputHint": "One country per line: iso2, iso3, name, currency. For example: MV, MDV, Maldives, MVR",
      "submit": "Import",
      "parseError": "Line {line} could not be read. Expected: iso2, iso3, name, currency.",
      "emptyInput": "Paste at least one line.",
      "failed": "The import did not run.",
      "resultTitle": "Import finished",
      "created": "Created",
      "updated": "Updated",
      "skipped": "Skipped",
      "errorsTitle": "Rows the server refused",
      "close": "Done"
    },
    "packs": {
      "title": "Tax packs",
      "description": "A country's statutory content — jurisdictions, regimes, codes and the ordered rules that stack them — versioned, diffed and published to tenants.",
      "tableLabel": "Tax packs",
      "newPack": "New draft",
      "countryFilter": "Country",
      "statusFilter": "Status",
      "anyCountry": "Any country",
      "anyStatus": "Any status",
      "emptyTitle": "No tax packs yet",
      "emptyDescription": "A pack is one country's statutory content. Draft the first one, then publish it for tenants to adopt.",
      "loadFailed": "The pack list could not be loaded.",
      "draftFirst": "Draft the first pack",
      "system": "System"
    },
    "status": {
      "draft": "Draft",
      "draftMeaning": "Editable. Not visible to any tenant.",
      "published": "Published",
      "publishedMeaning": "Frozen. Tenants can adopt this version.",
      "withdrawn": "Withdrawn",
      "withdrawnMeaning": "No longer offered. Tenants already on it keep resolving against it."
    },
    "create": {
      "title": "New tax pack draft",
      "description": "A draft starts empty, or as a copy of a published version you then amend.",
      "countryLabel": "Country",
      "countryHint": "The country whose statutory content this pack carries.",
      "countryPlaceholder": "Select a country",
      "baseLabel": "Copy from",
      "baseHint": "Clones that version's whole payload into the new draft. Leave empty to start from nothing.",
      "baseNone": "Start empty",
      "titleLabel": "Title",
      "titleHint": "What changed and why, in a few words — e.g. \"TGST 17% from January 2027\".",
      "submit": "Create draft",
      "failed": "The draft could not be created.",
      "countryRequired": "Choose a country."
    },
    "detail": {
      "loadFailed": "This pack could not be loaded.",
      "notFound": "No such pack",
      "notFoundDescription": "It may have been deleted while it was still a draft.",
      "backToList": "Back to tax packs",
      "overview": "Overview",
      "content": "Content",
      "diff": "Changes",
      "adoption": "Adoption",
      "changelogLabel": "Changelog",
      "changelogHint": "Read by every tenant deciding whether to accept this version. Write it for them, not for us.",
      "titleLabel": "Title",
      "metaSaved": "Saved.",
      "metaFailed": "The change could not be saved.",
      "contentHash": "Content hash",
      "contentHashHint": "SHA-256 of the canonical payload. A tenant's activation records it, so a version can be proven identical to what was published.",
      "baseVersion": "Copied from",
      "submittedBy": "Submitted by",
      "publishedBy": "Published by",
      "withdrawnBy": "Withdrawn by",
      "withdrawReason": "Reason for withdrawal",
      "immutable": "Published content is frozen",
      "immutableDescription": "This version cannot be edited. Draft a new one from it to make a change.",
      "deleteTitle": "Delete this draft",
      "deleteConsequence": "The draft and every row in it are removed. Nothing that has been published is touched.",
      "deleteConfirm": "Delete draft",
      "deleteFailed": "The draft could not be deleted."
    },
    "sections": {
      "title": "Payload",
      "description": "Eleven tables make up a pack. Order matters in one of them, and that one is marked.",
      "jurisdictions": "Jurisdictions",
      "jurisdictionsHint": "The tax geography: country, subdivision and locality levels a code can be pinned to.",
      "regimes": "Regimes",
      "regimesHint": "One filing system each — a VAT, a withholding tax, a levy, a service charge.",
      "tax-codes": "Tax codes",
      "tax-codesHint": "The rates themselves, effective-dated. Never edited in place once published.",
      "rules": "Rules",
      "rulesHint": "Which codes apply to a supply, matched on direction, supply type, party class and channel.",
      "rule-entries": "Rule entries",
      "rule-entriesHint": "The ordered, compounding stack inside a rule. Sequence is arithmetic here, not presentation.",
      "pos-rules": "Place of supply",
      "pos-rulesHint": "Whether origin or destination governs, and what happens when neither side is registered.",
      "price-basis": "Price basis",
      "price-basisHint": "Whether a channel's prices are quoted tax-inclusive or tax-exclusive.",
      "return-defs": "Return definitions",
      "return-defsHint": "The forms this regime files, and how often.",
      "return-boxes": "Return boxes",
      "return-boxesHint": "Each box on a form, and the predicate that decides which tax lines land in it.",
      "doc-rules": "Document rules",
      "doc-rulesHint": "Statutory numbering, gapless sequences, void semantics and e-invoicing per document type.",
      "payroll-rules": "Payroll rules",
      "payroll-rulesHint": "Statutory payroll components — contributions, thresholds, minimum leave."
    },
    "grid": {
      "addRow": "Add row",
      "deleteRow": "Delete row",
      "emptyTitle": "No {section} rows yet",
      "emptyDescription": "Add the first row, or copy a published version into this draft when you create it.",
      "loadFailed": "These rows could not be loaded.",
      "readOnly": "This pack is published. Its content is frozen.",
      "saveFailed": "The row could not be saved.",
      "deleteFailed": "The row could not be deleted.",
      "deleteConsequence": "The row is removed from this draft. Published versions are unaffected.",
      "deleteConfirm": "Delete row",
      "deleteTitle": "Delete {label}?",
      "staleReloaded": "Somebody else changed this row while you had it open. It has been reloaded — reapply your change and save again.",
      "required": "This field is required.",
      "invalidJson": "This is not valid JSON.",
      "invalidNumber": "Enter a whole number.",
      "invalidDecimal": "Enter a decimal figure, e.g. 0.080000.",
      "createTitle": "Add a {section} row",
      "editTitle": "Edit {label}",
      "jsonHint": "A JSON object. Leave empty for none.",
      "actions": "Row actions"
    },
    "stack": {
      "title": "Compounding order",
      "description": "Each entry is charged on the base the one before it leaves behind. Move an entry and the tax on every invoice this rule governs changes.",
      "ruleLabel": "Rule",
      "rulePlaceholder": "Select a rule",
      "noRules": "This pack has no rules yet",
      "noRulesDescription": "Add a rule first; entries hang off one.",
      "noEntries": "This rule computes nothing yet",
      "noEntriesDescription": "Add the first tax code to the stack. The first entry is normally charged on net.",
      "addEntry": "Add to stack",
      "position": "Position {n}",
      "onNet": "on net",
      "onNetPlus": "on net + {codes}",
      "onNetPlusNothing": "on net — nothing precedes it",
      "moveUp": "Move earlier",
      "moveDown": "Move later",
      "moveUpHint": "Alt + Up",
      "moveDownHint": "Alt + Down",
      "reorderFailed": "The order could not be saved. Nothing was changed.",
      "reordered": "Order saved.",
      "listLabel": "Compounding stack for {rule}",
      "warnFirstCompound": "The first entry compounds on nothing. It behaves exactly like \"on net\" — set it to net, or move a charge in front of it.",
      "readOnly": "Published content is frozen. Draft a new version to change the order."
    },
    "diff": {
      "title": "Changes",
      "description": "What this pack changes against a published version. Read it before publishing: a rate that moves here moves on every invoice a tenant issues.",
      "againstLabel": "Compare against",
      "againstHint": "Any published version of the same country.",
      "noBaseline": "No published version to compare with",
      "noBaselineDescription": "This is the country's first pack. Everything in it is new.",
      "identical": "No differences",
      "identicalDescription": "This pack's payload is identical to v{version}.",
      "loadFailed": "The comparison could not be loaded.",
      "added": "Added",
      "changed": "Changed",
      "withdrawn": "Withdrawn",
      "addedCount": "{count} added",
      "changedCount": "{count} changed",
      "withdrawnCount": "{count} withdrawn",
      "sectionLabel": "Differences in {section}",
      "field": "Field",
      "before": "Before",
      "after": "After",
      "statutoryWarning": "This comparison changes a rate or an effective date.",
      "statutoryWarningDescription": "Tenants on the current version will be asked to validate before they accept it.",
      "filterAll": "Everything",
      "filterAdded": "Added only",
      "filterChanged": "Changed only",
      "filterWithdrawn": "Withdrawn only",
      "expandRow": "Show fields",
      "collapseRow": "Hide fields"
    },
    "validationPanel": {
      "title": "Validation",
      "description": "Structural checks over the whole payload — dangling references, cycles, overlapping effective dates.",
      "run": "Run validation",
      "running": "Checking…",
      "valid": "The payload is consistent",
      "validDescription": "Every reference resolves and no rule contradicts another.",
      "invalid": "{count} issue found | {count} issues found",
      "invalidDescription": "A pack cannot be published until every one of these is resolved.",
      "failed": "Validation could not be run.",
      "issueSection": "Section",
      "issueRow": "Row",
      "issueField": "Field",
      "issueMessage": "Problem",
      "notRunTitle": "Not checked yet",
      "notRunDescription": "Run the structural check to see whether this payload would publish."
    },
    "publish": {
      "submitTitle": "Submit for publication",
      "submitDescription": "Submitting freezes nothing. It records that you consider this draft ready, so a second operator can publish it.",
      "submitNoteLabel": "What changed",
      "submitNoteHint": "The operator who publishes reads this. Say what moved and from when.",
      "submit": "Submit",
      "submitFailed": "The pack could not be submitted.",
      "title": "Publish v{version}",
      "description": "Publishing freezes this payload and offers it to every tenant in {country}.",
      "dualControlTitle": "Two operators, always",
      "dualControlDescription": "The operator who submitted a pack cannot publish it. This is enforced by the database, not only by this screen.",
      "youSubmitted": "You submitted this pack, so you cannot publish it. Another owner has to.",
      "notSubmitted": "This pack has not been submitted yet. Submit it first.",
      "notValid": "This pack has {count} unresolved validation issue. Resolve it before publishing. | This pack has {count} unresolved validation issues. Resolve them before publishing.",
      "summaryTitle": "What tenants will be offered",
      "summaryNone": "No comparison was run. Publish anyway only if you know what changed.",
      "noteLabel": "Publication note",
      "noteHint": "Recorded on the audit trail and shown to tenants alongside the changelog.",
      "confirm": "Publish",
      "failed": "The pack could not be published.",
      "withdrawTitle": "Withdraw v{version}",
      "withdrawConsequence": "The version stops being offered to new tenants. Tenants already on it keep resolving against it — nothing they have posted changes.",
      "withdrawConfirm": "Withdraw version",
      "withdrawReasonLabel": "Reason",
      "withdrawReasonHint": "Recorded on the audit trail and shown to tenants running this version.",
      "withdrawFailed": "The version could not be withdrawn."
    },
    "adoption": {
      "title": "Pack adoption",
      "description": "Which tenant runs which version of which country's pack, and who owes an update.",
      "tableLabel": "Pack adoption by tenant",
      "tenant": "Tenant",
      "country": "Country",
      "running": "Running",
      "latest": "Latest published",
      "state": "State",
      "activatedOn": "Activated",
      "pendingSince": "Pending since",
      "searchLabel": "Search tenants",
      "searchPlaceholder": "Name or slug",
      "emptyTitle": "No tenants yet",
      "emptyDescription": "Adoption is per tenant. Provision one and activate a country's pack for it.",
      "emptyFilteredTitle": "No tenant matches",
      "emptyFilteredDescription": "Clear the search to see every tenant.",
      "loadFailed": "The tenant list could not be loaded.",
      "rowUnavailable": "Could not be read",
      "rowUnavailableHint": "This tenant's schema could not be opened. A suspended or archived tenant answers this way by design.",
      "noActivation": "No pack activated",
      "noActivationHint": "This tenant resolves no tax through a pack yet.",
      "states": {
        "current": "Current",
        "currentHint": "Running the newest published version.",
        "pending": "Update pending",
        "pendingHint": "A newer version is published and has not been accepted yet.",
        "overdue": "Overdue",
        "overdueHint": "A newer version has been published for more than {days} days and is still not accepted.",
        "failed": "Validation failed",
        "failedHint": "The tenant's sandbox validation of the pending version did not pass.",
        "unknown": "Unknown",
        "unknownHint": "No published version is on record for this country, so there is nothing to compare against."
      },
      "summary": {
        "tenants": "Tenants",
        "current": "Current",
        "pending": "Pending",
        "overdue": "Overdue"
      },
      "scopeNote": "Counts describe the tenants on this page, not the whole estate — the list is cursor-paginated."
    },
    "fields": {
      "addressValidation": "Address validation",
      "amount": "Amount",
      "baseKind": "Charged on",
      "basis": "Basis",
      "boxNo": "Box",
      "channel": "Channel",
      "channelClass": "Channel class",
      "code": "Code",
      "componentKind": "Component",
      "country": "Country",
      "currency": "Currency",
      "defaultCurrency": "Default currency",
      "defaultTimezone": "Default timezone",
      "description": "Description",
      "direction": "Direction",
      "docType": "Document type",
      "dueRule": "Due rule",
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to",
      "einvoiceProvider": "E-invoice provider",
      "einvoiceRequired": "E-invoice required",
      "filingCurrency": "Filing currency",
      "formReference": "Form reference",
      "formula": "Formula",
      "formulaKind": "Formula",
      "frequency": "Frequency",
      "gapless": "Gapless",
      "geoCountryId": "Linked country",
      "geoLocalityId": "Linked locality",
      "geoSubdivisionId": "Linked subdivision",
      "inputAccountCode": "Input account",
      "isActive": "Active",
      "isOverridable": "Overridable",
      "isRecoverable": "Recoverable",
      "iso2": "ISO alpha-2",
      "iso3": "ISO alpha-3",
      "itemClass": "Item class",
      "jurisdictionCode": "Jurisdiction",
      "kind": "Kind",
      "label": "Label",
      "level": "Level",
      "localityLabel": "Locality label",
      "name": "Name",
      "note": "Note",
      "numberFormat": "Number format",
      "numberPadding": "Number padding",
      "numberPrefix": "Number prefix",
      "numericCode": "ISO numeric",
      "officialName": "Official name",
      "outputAccountCode": "Output account",
      "params": "Parameters",
      "parentCode": "Parent",
      "parentId": "Parent",
      "partyClass": "Party class",
      "payableAccountCode": "Payable account",
      "phoneCc": "Dialling code",
      "postalCode": "Postal code",
      "predicate": "Predicate",
      "priceBasis": "Price basis",
      "priority": "Priority",
      "published": "Published",
      "rate": "Rate",
      "regimeCode": "Regime",
      "registrationHint": "Registration hint",
      "registrationPattern": "Registration pattern",
      "retentionYears": "Retention (years)",
      "returnDefCode": "Return",
      "reviewDue": "Review due",
      "reviewPeriodMonths": "Review every (months)",
      "rounding": "Rounding",
      "roundingMode": "Rounding mode",
      "ruleId": "Rule",
      "sequenceNo": "Seq",
      "sign": "Sign",
      "sortOrder": "Order",
      "sourceCitation": "Source",
      "statutory": "Statutory",
      "statutoryLanguage": "Statutory language",
      "subdivisionId": "Subdivision",
      "subdivisionLabel": "Subdivision label",
      "supplyType": "Supply type",
      "taxCode": "Tax code",
      "timezone": "Timezone",
      "treatment": "Treatment",
      "unitCurrency": "Unit currency",
      "unitLabel": "Unit",
      "unregisteredTaxCode": "Unregistered code",
      "valueKind": "Value",
      "version": "Version",
      "voidConsumesNumber": "Void consumes number"
    },
    "enums": {
      "jurisdictionLevel": {
        "country": "Country",
        "subdivision": "Subdivision",
        "locality": "Locality"
      },
      "regimeKind": {
        "VAT": "VAT / GST",
        "WHT": "Withholding",
        "LEVY": "Levy",
        "CHARGE": "Service charge",
        "SALES_TAX": "Sales tax"
      },
      "taxCodeKind": {
        "VAT": "VAT / GST",
        "WHT": "Withholding",
        "LEVY": "Levy",
        "CHARGE": "Service charge"
      },
      "treatment": {
        "standard": "Standard",
        "zero_rated": "Zero-rated",
        "exempt": "Exempt",
        "reverse_charge": "Reverse charge",
        "out_of_scope": "Out of scope"
      },
      "basis": {
        "percent": "Percentage",
        "per_unit": "Per unit"
      },
      "rounding": {
        "line": "Per line",
        "document": "Per document"
      },
      "roundingMode": {
        "half_up": "Half up",
        "half_even": "Half even"
      },
      "direction": {
        "input": "Input",
        "output": "Output",
        "any": "Either"
      },
      "supplyType": {
        "goods": "Goods",
        "services": "Services",
        "accommodation": "Accommodation",
        "fnb": "Food and beverage",
        "digital": "Digital",
        "transport": "Transport",
        "other": "Other"
      },
      "partyClass": {
        "registered": "Registered",
        "unregistered": "Unregistered",
        "export": "Export",
        "government": "Government",
        "exempt": "Exempt",
        "non_resident": "Non-resident"
      },
      "baseKind": {
        "net": "Net",
        "net_plus_prior": "Net plus preceding"
      },
      "posBasis": {
        "origin": "Origin",
        "destination": "Destination",
        "hybrid": "Hybrid"
      },
      "posFallback": {
        "origin": "Fall back to origin",
        "out_of_scope": "Out of scope"
      },
      "channelClass": {
        "default": "Default",
        "pos": "Point of sale",
        "hospitality": "Hospitality",
        "retail": "Retail",
        "wholesale": "Wholesale",
        "b2b": "Business to business",
        "portal": "Portal",
        "web": "Web"
      },
      "priceBasis": {
        "inclusive": "Tax inclusive",
        "exclusive": "Tax exclusive"
      },
      "frequency": {
        "monthly": "Monthly",
        "quarterly": "Quarterly",
        "biannual": "Twice a year",
        "annual": "Annually"
      },
      "valueKind": {
        "base": "Base",
        "tax": "Tax",
        "computed": "Computed"
      },
      "componentKind": {
        "earning": "Earning",
        "deduction": "Deduction",
        "employer_cost": "Employer cost",
        "leave_minimum": "Leave minimum",
        "threshold": "Threshold"
      },
      "formulaKind": {
        "fixed": "Fixed",
        "percent": "Percentage",
        "slab": "Slab",
        "per_unit": "Per unit"
      },
      "addressValidation": {
        "enforce": "Enforce",
        "warn": "Warn",
        "allow": "Allow"
      },
      "subdivisionKind": {
        "state": "State",
        "province": "Province",
        "atoll": "Atoll",
        "region": "Region",
        "emirate": "Emirate",
        "district": "District",
        "county": "County",
        "prefecture": "Prefecture",
        "territory": "Territory",
        "other": "Other"
      },
      "localityKind": {
        "city": "City",
        "town": "Town",
        "island": "Island",
        "zone": "Zone",
        "free_zone": "Free zone",
        "district": "District",
        "village": "Village",
        "other": "Other"
      }
    },
    "tenantTaxPacks": {
      "title": "Tax packs for {name}",
      "description": "The country packs this tenant has activated, and the operator's own path to activate one.",
      "backToAdoption": "Back to adoption",
      "loadFailed": "This tenant's activated tax packs could not be loaded.",
      "tenantLoadFailed": "This tenant could not be loaded.",
      "tableLabel": "Tax packs activated by this tenant",
      "emptyTitle": "No pack activated yet",
      "emptyDescription": "Activate a country's published pack for this tenant to give it live tax resolution.",
      "activate": "Activate a pack",
      "writeNote": "Activating a pack requires the owner or support role.",
      "manageLink": "Manage {name}'s tax packs"
    },
    "tenantActivate": {
      "title": "Activate a tax pack",
      "description": "Copies the country's latest published pack into this tenant's own schema.",
      "countryLabel": "Country",
      "countryHint": "Defaults to the tenant's own registered country.",
      "countryPlaceholder": "Tenant's registered country",
      "effectiveFromLabel": "Effective from",
      "effectiveFromHint": "Defaults to today.",
      "submit": "Activate",
      "failed": "The pack could not be activated.",
      "success": "Pack activated."
    }
  }
}
